<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="40%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="分类名称"
          prop="evaluationCategoryName"
        >
          <el-input v-model="createForm.evaluationCategoryName" />
        </el-form-item>
        <el-form-item
          label="选择题出题数"
          prop="choiceCount"
        >
          <el-input v-model="createForm.choiceCount" />
        </el-form-item>
        <el-form-item
          label="判断题出题数"
          prop="trueFalseCount"
        >
          <el-input v-model="createForm.trueFalseCount" />
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table
          :data="createForm.scoreList"
          border
        >
          <el-table-column
            prop="score"
            label="分数"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.score">{{ scope.row.score }}</span>
              <span v-if=" scope.row.score === ''">
                <i
                  class="el-icon-plus cursor"
                  @click="openItemDialog(scope)"
                />
              </span>
              <span v-else>
                <i
                  class="el-icon-edit-outline cursor"
                  @click="openItemDialog(scope)"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="scoreIntro"
            label="提示语句"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="item">
                <span v-if="scope.row.scoreIntro">{{ scope.row.scoreIntro }}</span>
                <span v-if="scope.row.scoreIntro === ''">
                  <i
                    class="el-icon-plus cursor"
                    @click="openItemDialog(scope)"
                  />
                </span>
                <span v-else>
                  <i
                    class="el-icon-edit-outline cursor"
                    @click="openItemDialog(scope)"
                  />
                </span>
                <el-dropdown
                  trigger="click"
                  @click.native.stop="openDropDown(scope.$index)"
                >
                  <span class="el-dropdown-link">
                    <svg-icon
                      name="more"
                    />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="deletedItem(scope.$index)">
                      删除
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          type="primary"
          class="add-column"
          icon="el-icon-plus"
          @click="addColumn"
        >
          新增一列
        </el-button>
      </div>
    </div>
    <evaluation-category-item-dialog
      :dialog-visible.sync="categoeyItemDialogVisible"
      :item="evaluationCategoryItem"
      @confirm="getScoreItem"
    />
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import evaluationCategoryItemDialog from './evaluationCategoryItemDialog.vue';

export default {
  name: 'ScheduleTplDialog',
  components: { customeDialog, evaluationCategoryItemDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      title: '题目分类维护',
      cancelText: '取消',
      dateList: [],
      activeItem: {},
      categoeyItemDialogVisible: false,
      evaluationCategoryItem: null,
      createForm: {
        id: null,
        evaluationCategoryName: null,
        choiceCount: null,
        trueFalseCount: null,
        scoreList: [],
      },
      creatRules: {
        evaluationCategoryName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
        ],
        choiceCount: [
          {
            required: true, message: '请输入选择题出题数量', trigger: 'blur',
          },
        ],
        trueFalseCount: [
          {
            required: true, message: '请输入判断题出题数量', trigger: 'blur',
          },
        ],

      },
    };
  },
  watch: {
    item: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const {
              evaluationCategoryName,
              choiceCount,
              trueFalseCount,
              scoreList,
              id,
            } = val;
            this.createForm = {
              evaluationCategoryName,
              choiceCount,
              trueFalseCount,
              scoreList,
              id,
            };
          } else {
            this.createForm.id = null;
            this.createForm.scoreList = [];
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    // 删除一行
    deletedItem(index) {
      this.createForm.scoreList.splice(index, 1);
    },
    // 新增一行
    addColumn() {
      this.createForm.scoreList.push({
        score: '',
        scoreIntro: '',
      });
    },
    // 打开下拉弹窗
    openDropDown(index) {
      this.activeIndex = index;
    },
    // 打开弹窗编辑章节
    openItemDialog(scope) {
      this.activeIndex = scope.$index;
      this.evaluationCategoryItem = this._.cloneDeep(scope.row);
      this.categoeyItemDialogVisible = true;
    },
    // 获取编辑完成的得分提示
    getScoreItem(item) {
      this.createForm.scoreList.splice(this.activeIndex, 1, item);
    },
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('update:item', null);
      this.$refs.createForm.resetFields();
      this.$refs.createForm.clearValidate();
      console.log(this.createForm, 'close');
    },
    async confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.evaluationId = this.$route.params.id;
          const data = await axClient.evaluation.evaluationCategoryUpsert(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改题目分类');
          } else {
            this.$message.success('新增题目分类');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
          this.$refs.createForm.clearValidate();
          this.$refs.createForm.resetFields();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  & > div {
    border: 1px solid rgba($--base-color-grey, $alpha: 0.3);
    box-sizing: border-box;
    border-radius: 3px;
  }
  .table {
    flex: 2;
    border: none;
    .header {
      width: 80%;
      margin-left: 8%;
    }
    ::v-deep .el-table__row {
      .cell{
        justify-content: center;
        i{
          margin-left: 15px;
        }
      }
    }
    .item {
      padding-right: 50px;
      .el-dropdown{
        position: absolute;
        top: 0;
        bottom: 0;
        right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .el-dropdown-link{
          svg{
            height: 16px;
          }
        }
      }
    }
  }
  .add-column {
    width: 30%;
    margin: auto;
    display: block;
    margin-top: 20px;
  }
}
</style>
